import React, { useEffect, useState } from 'react';
import compose from 'recompose/compose';
import { withRouter, Link } from 'react-router-dom';
import { getCommunityBySlugQuery } from 'shared/graphql/queries/community/getCommunity';
import { withApollo } from 'react-apollo';
import { Nav, Action, Left, Title, AvatarLink } from './style';
import SettingsIcon from '@material-ui/icons/Settings';
import HomeIcon from '@material-ui/icons/Home';
import Tooltip from '@material-ui/core/Tooltip';

const AdminExploreNav = () => {
  return (
    <React.Fragment>
      <div
        style={{
          width: '95%',
          margin: '0 auto',
          paddingLeft: '10px',
          maxWidth: '1076px',
          display: 'flex',
        }}
      >
        <Title data-testid="crimson-community" style={{ paddingLeft: 0 }}>
          Launchpad
        </Title>
        <div style={{ cursor: 'pointer' }}>
          <Link to="/admin" data-testid="navigation-admin">
            <Tooltip title="Manage community">
              <SettingsIcon style={{ color: 'white' }} />
            </Tooltip>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

const AdminNav = () => {
  return (
    <React.Fragment>
      <Left>
        <Action>Group management</Action>
        <Title data-testid="community-management">Community Management</Title>
      </Left>

      <div style={{ marginRight: '2.5%', cursor: 'pointer' }}>
        <Link to="/explore" data-testid="navigation-explore">
          {/* TODO: judge the users' role to show manage admin */}
          <Tooltip title="Community Homepage">
            <HomeIcon style={{ color: 'white' }} />
          </Tooltip>
        </Link>
      </div>
    </React.Fragment>
  );
};
const EditGroupNav = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>
            &nbsp; Edit Group{' '}
          </Action>
        </Link>
        <Title data-testid="community-management">Community Management</Title>
      </Left>
    </React.Fragment>
  );
};

const ExpertsNav = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>
            &nbsp; Expert management{' '}
          </Action>
        </Link>
        <Title data-testid="community-management">Community Management</Title>
      </Left>
      <div style={{ marginRight: '2.5%', cursor: 'pointer' }}>
        <Link to="/explore">
          {/* TODO: judge the users' role to show manage admin */}
          <Tooltip title="Community Homepage">
            <HomeIcon style={{ color: 'white' }} />
          </Tooltip>
        </Link>
      </div>
    </React.Fragment>
  );
};

const ManageMembers = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>{' '}
            &nbsp;New Group{' '}
          </Action>
        </Link>
        <Title data-testid="community-management">Community Management</Title>
      </Left>
    </React.Fragment>
  );
};

const ManageNewCommunity = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>{' '}
            &nbsp;New Group{' '}
          </Action>
        </Link>
        <Title data-testid="community-management">Community Management</Title>
      </Left>
    </React.Fragment>
  );
};

const ManagePosts = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>
            &nbsp;Posts management{' '}
          </Action>
        </Link>
        <Title>Posts Management</Title>
      </Left>
      <div style={{ marginRight: '2.5%', cursor: 'pointer' }}>
        <Link to="/explore">
          {/* TODO: judge the users' role to show manage admin */}
          <Tooltip title="Community Homepage">
            <HomeIcon style={{ color: 'white' }} />
          </Tooltip>
        </Link>
      </div>
    </React.Fragment>
  );
};

const ManageEvents = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>
            &nbsp;Events management{' '}
          </Action>
        </Link>
        <Title>Events Management</Title>
      </Left>
      <div style={{ marginRight: '2.5%', cursor: 'pointer' }}>
        <Link to="/explore">
          {/* TODO: judge the users' role to show manage admin */}
          <Tooltip title="Community Homepage">
            <HomeIcon style={{ color: 'white' }} />
          </Tooltip>
        </Link>
      </div>
    </React.Fragment>
  );
};

const ManageGroupideas = () => {
  return (
    <React.Fragment>
      <Left>
        <Link to="/admin">
          <Action>
            <AvatarLink to={'/admin'} data-testid="navigation-admin-groups">
              {' '}
              Group management &gt;{' '}
            </AvatarLink>
            &nbsp;Group ideas management{' '}
          </Action>
        </Link>
        <Title>Group ideas Management</Title>
      </Left>
      <div style={{ marginRight: '2.5%', cursor: 'pointer' }}>
        <Link to="/explore">
          {/* TODO: judge the users' role to show manage admin */}
          <Tooltip title="Community Homepage">
            <HomeIcon style={{ color: 'white' }} />
          </Tooltip>
        </Link>
      </div>
    </React.Fragment>
  );
};

const ExploreNav = () => {
  return (
    <React.Fragment>
      <div
        style={{
          width: '95%',
          margin: '0 auto',
          paddingLeft: '10px',
          maxWidth: '1076px',
        }}
      >
        <Title data-testid="crimson-community" style={{ paddingLeft: 0 }}>
          Launchpad
        </Title>
      </div>
    </React.Fragment>
  );
};

const DefaultNav = props => {
  const { title } = props;
  return (
    <React.Fragment>
      <Left>
        <>
          <Action>
            <AvatarLink to={'/explore'} data-testid="navigation-community">
              {' '}
              Community&nbsp;&gt;
            </AvatarLink>
            &nbsp;
            <AvatarLink
              to={'/explore?tab=groups'}
              data-testid="navigation-group"
            >
              Groups{' '}
            </AvatarLink>
          </Action>
        </>
        {title && <Title> {title}</Title>}
      </Left>
    </React.Fragment>
  );
};

const NoTitleRoutes = [
  '/manage/editGroup',
  '/manage/experts',
  '/manage/members',
  '/manage/posts',
  '/manage/events',
  '/manage/groupideas',
  '/manage/comments',
];

const Navigation = props => {
  const { currentUser, client } = props;
  const { pathname } = props.location;
  const [title, setTitle] = useState('');
  let Result;
  useEffect(async () => {
    const result = NoTitleRoutes.filter(path => pathname.includes(path));
    if (pathname === '/explore') {
      setTitle('Crimson  Community');
    } else if (result.length > 0) {
      setTitle('');
    } else if (pathname.includes('/profile')) {
      setTitle('Profile');
    } else {
      const slug = pathname.slice(1, pathname.length).split('/')[0];
      const { data } = await client.query({
        query: getCommunityBySlugQuery,
        variables: {
          slug,
        },
      });
      setTitle(data && data.community ? data.community.name : '');
    }
  }, [pathname, getCommunityBySlugQuery, NoTitleRoutes, setTitle, client]);
  if (
    pathname === '/explore' &&
    currentUser &&
    currentUser.role &&
    currentUser.canViewAdmin
  ) {
    Result = AdminExploreNav;
  } else if (pathname === '/admin') {
    Result = AdminNav;
  } else if (pathname.includes('/manage/editGroup')) {
    Result = EditGroupNav;
  } else if (pathname.includes('/manage/experts')) {
    Result = ExpertsNav;
  } else if (pathname.includes('/manage/members')) {
    Result = ManageMembers;
  } else if (pathname === '/manage/new/community') {
    Result = ManageNewCommunity;
  } else if (pathname.includes('/manage/posts')) {
    Result = ManagePosts;
  } else if (pathname.includes('/manage/events')) {
    Result = ManageEvents;
  } else if (pathname.includes('/manage/groupideas')) {
    Result = ManageGroupideas;
  } else if (pathname === '/explore') {
    Result = ExploreNav;
  } else {
    Result = DefaultNav;
  }
  return (
    <Nav>
      {' '}
      <Result title={title} />{' '}
    </Nav>
  );
};
export default compose(withApollo, withRouter)(Navigation);
